const config = {
  services: {
    store: {
      endpointName: 'store',
      base: 'Store',
    },
    storeRegistration: {
      endpointName: 'storeRegistration',
      base: 'StoreRegistration',
    },
  },
};
export default config;